const commaSeparate = (arr: string[]): string => arr.filter(Boolean).join(', ');

export default commaSeparate;
